// import { Paper, Divider, Typography, CircularProgress } from '@mui/material';
import { CircularProgress } from '@mui/material';
import PUProfile from '../../PUProfile';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getTrendings, noReloadUpdateTrendings, resetTrendings } from '../../../../redux/actions/trending';
import { VirtuosoGrid } from 'react-virtuoso';
import useDidMountEffect from '../../../utils/useDidMountEffect';

import './style.scss';
import './style.darkmode.scss';

const TrendingWidget = ({ users, busy, keyword, total }) => {
    const dispatch = useDispatch();

    const [pageChange, setPageChange] = useState(0);
    const [reset, setReset] = useState(0);

    const fetchTrendings = () => {
        dispatch(getTrendings({
            keyword: keyword,
            perPage: 15,
            skip: users.length,
            trending: true
        }));
    };

    useDidMountEffect(() => {
        dispatch(resetTrendings());
        setReset(reset => reset + 1);
        return () => {
        };
    }, [keyword]);

    useDidMountEffect(() => {
        fetchTrendings();
    }, [pageChange]);

    useEffect(() => {
        fetchTrendings();
    }, [reset]);

    const handleTrendingEnd = () => {
        setPageChange(pageChange => pageChange + 1);
    };

    return <div className='trending-widget'>
        <div
            className='trending-widget__header'
        >
            <h3>Trending</h3>
        </div>

        {
            users && users.length > 0
                ? <VirtuosoGrid
                    style={{
                        height: 'calc(100vh - 77px)'
                    }}
                    totalCount={total}
                    endReached={handleTrendingEnd}
                    itemClassName='user__card'
                    data={users}
                    itemContent={(index, user) => <React.Fragment>
                        <PUProfile user={user} />
                    </React.Fragment>}
                />
                : null
        }

        {
            !busy && users && users.length <= 0
                ? <div style={{ textAlign: 'center', padding: '12px' }}>
                    <p>No creator found</p>
                </div>
                : null
        }

        {
            busy
                ? (
                    users && users.length > 0
                    ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50px' }}>
                            <CircularProgress size={25} color='primary' />
                        </div>
                        : <div style={{ display: 'flex', justifyContent: 'center', minHeight: '250px', paddingTop: '75px' }}>
                            <CircularProgress color='primary' />
                        </div>
                ) : null

            // // from 1472
            // busy && users.length === 0
            //     ? <div style={{ display: 'flex', paddingTop: users.length === 0 ? '80px' : 'unset', justifyContent: 'center', minHeight: '250px' }}>
            //         <CircularProgress size={40} />
            //     </div>
            //     : null
        }
    </div>;
};

const mapStateToProps = state => ({
    users: state.trending.users,
    busy: state.trending.busy,
    keyword: state.trending.keyword,
    total: state.trending.total
});

export default connect(mapStateToProps)(TrendingWidget);